module.exports = __webpack_public_path__ + "static/media/mh_entrium_08.de9ed3aa.png";